import { CollectionProductInterface } from "../interfaces/collections/CollectionInterface";

export const collectionProductMapper = (
    products: CollectionProductInterface[],
    numberOfProducts: number,
): CollectionProductInterface[][] => {
    const productCollection: CollectionProductInterface[][] = [];

    let counter = 0;
    let paginationCounter = 0;

    products.forEach((product: CollectionProductInterface) => {
        if (!productCollection[paginationCounter]) {
            productCollection[paginationCounter] = [];
        }

        productCollection[paginationCounter].push(product);

        counter++;
        if (counter === numberOfProducts) {
            paginationCounter++;
            counter = 0;
        }
    });

    return productCollection;
};
